import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appBackgroundImage]',
  standalone: true
})
export class BackgroundImageDirective implements OnInit{

  @Input({required:true}) 
  url!:string;

  constructor(private elementRef:ElementRef, private renderer: Renderer2) {}
  
  ngOnInit() {
      this.renderer.setStyle(
          this.elementRef.nativeElement,
          'backgroundImage',
          `url(${this.url})`
      );
  }

}
